import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import usersLogsSlice from '../reducers/usersLogs.slice'

const persistConfig = {
  key: 'usersLogsSlice',
  storage,
}

export const persistedUsersLogsReducer = persistReducer(persistConfig, usersLogsSlice)